import request from '@/utils/request'


// 查询森林列表
export function listForest(query) {
  return request({
    url: '/forest/forest/list',
    method: 'get',
    params: query
  })
}

// 查询森林分页
export function pageForest(query) {
  return request({
    url: '/forest/forest/page',
    method: 'get',
    params: query
  })
}

// 查询森林详细
export function getForest(data) {
  return request({
    url: '/forest/forest/detail',
    method: 'get',
    params: data
  })
}

// 新增森林
export function addForest(data) {
  return request({
    url: '/forest/forest/add',
    method: 'post',
    data: data
  })
}

// 修改森林
export function updateForest(data) {
  return request({
    url: '/forest/forest/edit',
    method: 'post',
    data: data
  })
}

// 删除森林
export function delForest(data) {
  return request({
    url: '/forest/forest/delete',
    method: 'post',
    data: data
  })
}
